import React, { useState, useEffect } from "react";

import { CountrySelector } from "react-international-phone";

import "./InputWithInnerLabel.scss";
import "react-international-phone/style.css";

const InputWithInnerLabel = ({
  stateValue,
  setStateValue,
  type = "text",
  labelText,
  idText,
  phoneInput = false,
  updateCountryFromPhoneNumber,
  redBorder = false,
  disabled = false,
  minLength,
  onChangeRules = (value) => {return true}
}) => {
  const [country, setCountry] = useState("ae");
  const [Init, setInit] = useState(true);

  const handleCountryChange = ({ iso2, dialCode }) => {
    setStateValue(`+${dialCode}`);
    setCountry(iso2);
  };

  const handleValueChange = (value) => {
    if(onChangeRules(value)) setStateValue(value);
    else return;
  }

  useEffect(() => {
    if (phoneInput) {
      if (stateValue) {
        updateCountryFromPhoneNumber(stateValue, setCountry);
      }
    }
  }, [stateValue]);

  useEffect(() => {
    if (phoneInput) {
      if (!stateValue) {
        setStateValue(`+971`);
      }
    }
  }, []);

  return (
    <div className="input-inner-container">
      {phoneInput ? (
        <>
          <div className="phone-inner-container">
            <div className="country-inner-selector">
              <CountrySelector
                selectedCountry={country}
                onSelect={handleCountryChange}
                buttonStyle={{ backgroundColor: "transparent", border: "none" }}
              />
            </div>
            <input
              className="account-inner-input not-full-width"
              id={`account-${idText}`}
              type={type}
              value={stateValue}
              maxLength={45}
              style={{border: `1px solid ${(redBorder || (minLength && stateValue?.length < minLength)) && !(disabled && stateValue?.trim() !== "") ? "red" : "#00000040"}`}}
              onChange={(e) => {
                setStateValue(e.target.value);
                setInit(false);
              }}
              disabled={disabled}
            />
            <label className="account-inner-label" htmlFor={`account-${idText}`}>
              {labelText}
            </label>
          </div>
        </>
      ) : (
        <>
          <input
            className="account-inner-input"
            id={`account-${idText}`}
            type={type}
            value={stateValue}
            maxLength={45}
            style={{border: `1px solid ${((redBorder && stateValue?.trim() === "") || (minLength && stateValue?.length < minLength)) && !(disabled && stateValue?.trim() !== "") ? "red" : "#00000040"}`}}
            onChange={(e) => handleValueChange(e.target.value)}
            disabled={disabled}
          />
          <label className="account-inner-label" htmlFor={`account-${idText}`}>
            {labelText}
          </label>
        </>
      )}
    </div>
  );
};

export default InputWithInnerLabel;
